import { BodyRegular } from "../../shared/typography"

export const PRIVACY_EMAIL = 'xyz@cc.com'

export const tableHead: any = [
    {
        Header: <BodyRegular>Category</BodyRegular>,
        accessor: 'col1',
    },
    {
        Header: <BodyRegular>Examples</BodyRegular>,
        accessor: 'col2',
    },
    {
        Header: <BodyRegular>Collected</BodyRegular>,
        accessor: 'col3',
    },
    {
        Header: <BodyRegular>Categories of Recipients</BodyRegular>,
        accessor: 'col4',
    }
]

export const tableData: any = [
    {
        col1: <BodyRegular>Identifiers</BodyRegular>,
        col2: <BodyRegular>Name, address, e-mail address, IP address</BodyRegular>,
        col3: <BodyRegular>Yes</BodyRegular>,
        col4: <BodyRegular>Organizations providing services to Fantasy</BodyRegular>,
    },
    {
        col1: <BodyRegular>Personal information categories listed in the California Customer Records statute</BodyRegular>,
        col2: <BodyRegular>Name, professional-related information; and employment-related information</BodyRegular>,
        col3: <BodyRegular>Yes</BodyRegular>,
        col4: <BodyRegular>Organizations providing services to Fantasy</BodyRegular>,
    },
    {
        col1: <BodyRegular>Protected classification characteristics under California or federal law</BodyRegular>,
        col2: <BodyRegular>
            Name, age, citizenship, nationality, ancestry, religion or creed, marital
            status, medical condition, physical or mental disability, sex (including gender, gender
            identity, gender expression, pregnancy or childbirth and related medical conditions),
            sexual orientation, veteran or military status, proof of eligibility to work
        </BodyRegular>,
        col3: <BodyRegular>No</BodyRegular>,
        col4: <BodyRegular>None</BodyRegular>,
    },
    {
        col1: <BodyRegular>Internet or other similar network activity</BodyRegular>,
        col2: <BodyRegular>Browsing history, search history, information on a consumer's interaction with the Fantasy Services</BodyRegular>,
        col3: <BodyRegular>No</BodyRegular>,
        col4: <BodyRegular>None</BodyRegular>,
    },
    {
        col1: <BodyRegular>Geolocation data</BodyRegular>,
        col2: <BodyRegular>Location and movement data</BodyRegular>,
        col3: <BodyRegular>Yes</BodyRegular>,
        col4: <BodyRegular>Organizations providing services to Fantasy</BodyRegular>,
    },
    {
        col1: <BodyRegular>Professional or employment-related information</BodyRegular>,
        col2: <BodyRegular>Proof of eligibility to work, resumé, other professional-related information and employment-related information</BodyRegular>,
        col3: <BodyRegular>No</BodyRegular>,
        col4: <BodyRegular>None</BodyRegular>,
    },
    {
        col1: <BodyRegular>Biometric information</BodyRegular>,
        col2: <BodyRegular>None</BodyRegular>,
        col3: <BodyRegular>No</BodyRegular>,
        col4: <BodyRegular>None</BodyRegular>,
    },
    {
        col1: <BodyRegular>Education Information</BodyRegular>,
        col2: <BodyRegular>None</BodyRegular>,
        col3: <BodyRegular>No</BodyRegular>,
        col4: <BodyRegular>None</BodyRegular>,
    },
    {
        col1: <BodyRegular>Inferences from the foregoing</BodyRegular>,
        col2: <BodyRegular>None</BodyRegular>,
        col3: <BodyRegular>No</BodyRegular>,
        col4: <BodyRegular>None</BodyRegular>,
    },

]